<template>
  <div class="art-item item3-add-cont">
    <common-top :commonTopData="commonTopData"></common-top>
    <div class="page-title" v-text="pageTitle"></div>
    <div class="top-title">
      <el-form class="add-form" :model="addForm" :disabled="isDisabled" :label-width="labelWidth">
        <el-form-item label="创作者昵称" prop="author">
          <el-input
            v-model="addForm.author"
            placeholder="请输入"
            maxlength="20"
            clearable
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="标签">
          <div class="tips">用于推荐、查询（请至少选择1个）</div>
          <el-select @change="testfn" v-model="addForm.tags" multiple filterable allow-create default-first-option placeholder="请选择" ref="tagbox">
            <el-option
              v-for="item in taglist"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <!-- <el-form-item label="热度值">
          <el-input
            v-model="addForm.view_num"
            placeholder="请输入"
       
          ></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="展示标签" prop="title">
          <div class="tips">用于推荐、查询</div>
          <el-select @change="testfn2" v-model="addForm.show_tags" multiple filterable allow-create default-first-option placeholder="请选择" ref="tagbox">
            <el-option
              v-for="item in tagList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
    </div>
    <div class="content">
      <div class="content-title">内容配置</div>
      <el-form class="add-form" :model="addForm" :label-width="labelWidth">
        <el-form-item>
           <el-radio-group class="art-radio-group" v-model="addForm.displayType" size="small">
            <el-radio-button :label="1">横长形</el-radio-button>
            <el-radio-button :label="2">竖长型</el-radio-button>
            <el-radio-button :label="3">发现艺术</el-radio-button>
            <el-radio-button :label="4">正方形</el-radio-button>
            
          </el-radio-group>
        </el-form-item>
      </el-form>
      <el-form class="add-form" :model="addForm" :disabled="isDisabled" :label-width="labelWidth">
        
        <el-form-item label="展示图" prop="title">
          <w-upload-image
          v-if="addForm.displayType==1"
            style="overflow: hidden;"
            class="upload-img"
            :imgWidth="1920"
            :imgHeight="620"
            :size="10"
            :drag="true"
            accept=".jpg,.png,.webp"
            :tipsText="tipsText"
            @input="my_input"
            v-model="addForm.prev_url_imagesa" />
          <w-upload-image
          v-if="addForm.displayType==2"
            style="overflow: hidden;"
            class="upload-img"
            :imgWidth="1920"
            :imgHeight="620"
            :size="10"
            :drag="true"
            accept=".jpg,.png,.webp"
            :tipsText="tipsText"
            @input="my_input"
            v-model="addForm.prev_url_imagesb" />
            <w-upload-image
            v-if="addForm.displayType==3"
            style="overflow: hidden;"
            class="upload-img"
            :imgWidth="1920"
            :imgHeight="620"
            :drag="true"
            :size="10"
            accept=".jpg,.png,.webp"
            :tipsText="tipsText"
            @input="my_input"
            v-model="addForm.prev_url_imagesc" />
            <w-upload-image
            v-if="addForm.displayType==4"
            style="overflow: hidden;"
            class="upload-img"
            :imgWidth="1920"
            :drag="true"
            :imgHeight="620"
            :size="10"
            accept=".jpg,.png,.webp"
            :tipsText="tipsText"
            @input="my_input"
            v-model="addForm.prev_url_imagesd" />
         
        </el-form-item>
        <el-form-item label="分享图" prop="title">
          <w-upload-image
            style="overflow: hidden;"
            class="upload-img"
            :imgWidth="1920"
            :imgHeight="620"
            :size="10"
            :drag="true"
            accept=".jpg,.png,.webp"
            tipsText="932 * 932; png/jpg格式"
            @input="my_input2"
            v-model="addForm.share_img_url">
          </w-upload-image>
        </el-form-item>

        <el-form-item label="背景大图" prop="title">
          <w-upload-image
            style="overflow: hidden;"
            class="upload-img"
            :imgWidth="1920"
            :drag="true"
            :imgHeight="620"
            :size="10"
            accept=".jpg,.png,.webp"
            tipsText="png/jpg格式"
            @input="my_input2"
            v-model="addForm.prev_bg_url">
          </w-upload-image>
        </el-form-item>

        <!-- <el-form-item label="背景视频" prop="title">

          <w-upload-video
                    style="overflow: hidden"
                    :videoWidth="1920"
                    :videoHeight="620"
                    :drag="true"
                    :size="5"
                    tipsText="视频尺寸720x1600或者576x1280；大小不超过5M"
                    v-model="addForm.prev_bg_mp4"
                  >
                  </w-upload-video>
        </el-form-item> -->

        <el-form-item label="背景视频" prop="title">

          <upload-new
                    style="overflow: hidden"
                    :drag="true"
                    :size="5"
                    :tipsText="'视频尺寸720x1600 576x1280 576*1024；大小不超过5M'"
                    v-model="addForm.videoAll"
                  >
                  </upload-new>

               
        </el-form-item>


        <el-form-item label="标题">
          <el-input
            v-model="addForm.title"
            maxlength="20"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="副标题">
          <el-input
            v-model="addForm.subTitle"
            type="textarea"
            maxlength="50"
            show-word-limit
            resize="none"
          ></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input
            v-model="addForm.desc"
            type="textarea"
            maxlength="250"
            autosize
            show-word-limit
            resize="none"
          ></el-input>
        </el-form-item>
        <el-form-item label="跳转内容" class="jump-link-group">
          <el-radio-group class="art-radio-group" :class="{'disabled-box': isDisabledRadio}" v-model="addForm.type" :disabled="isDisabledRadio" size="small">
            <el-radio-button :label="0">
              <span @click="setType(0)">无跳转</span>
            </el-radio-button>
            <el-radio-button :label="1">
              <span @click="setType(1)">专题列表</span>
            </el-radio-button>
            <el-radio-button :label="2">
              <span @click="setType(2)">大图</span>
            </el-radio-button>
            <!-- <el-radio-button :label="3">
              <span @click="setType(3)">视频</span>
            </el-radio-button> -->
            <el-radio-button :label="4">
              <span @click="setType(4)">文章</span>
            </el-radio-button>
            <el-radio-button :label="5">
              <span @click="setType(5)">链接</span>
            </el-radio-button>
            <!-- <el-radio-button :label="6">
              <span @click="setType(6)">dpLink</span>
            </el-radio-button>
            <el-radio-button :label="7">
              <span @click="setType(7)">VR全景</span>
            </el-radio-button> -->
            <el-radio-button :label="8">
              <span @click="setType(8)">互动H5</span>
            </el-radio-button>
          </el-radio-group>
           <!-- 跳转内容选择 -->
          <div class="item1" v-show="item === 1">
            <el-button size="small" @click="selectFn">选择专题列表</el-button>
            <span class="tips" v-text="`${showObj.relationName}（内容数：${showObj.relationContents}）`"></span>
            
                  
          </div>
          <div class="item2" v-show="item === 2">
            <w-upload-image
              style="overflow: hidden;"
              class="upload-img"
              :imgWidth="1920"
              :imgHeight="620"
              :size="10"
              tipsText="png/jpg格式"
              v-model="addForm.bigPic">
            </w-upload-image>
          </div>
          <div class="item3" v-show="item === 3">
            <w-upload-video
              style="overflow: hidden;"
              :videoWidth="1920"
              :videoHeight="620"
              :size="10"
              tipsText="mp4格式"
              v-model="addForm.video">
            </w-upload-video>
          </div>
          <div class="item4" v-show="item === 4">
            <el-button size="small" @click="selectFn2">选择文章</el-button>
            <span class="tips" v-text="`${showObj.relationName}`"></span>
          </div>
          <div class="item5" v-show="item === 5">
            <el-input v-model="addForm.link" placeholder="请输入跳转链接"></el-input>
          </div>
          <div class="item6" v-show="item === 6">
            <el-input v-model="addForm.deepLink" placeholder="请输入dpLink参数链接"></el-input>
          </div>
          <div class="item7" v-show="item === 7">
            <add-vr v-model="addForm.vr"></add-vr>
            <!-- <el-input v-model="addForm.vr" placeholder="请输入VR参数链接"></el-input> -->
          </div>
          <div class="item8" v-show="item === 8">
            <div class="form-item form-item1">
              <span class="form-item-title">上传互动包</span>
              <!-- <upload-new
                    style="overflow: hidden;"
                :videoWidth="1920"
                :videoHeight="620"
                :size="10"
                :drag="true"
                accept=".zip"
                btnText='上传互动包'
                tipsText="zip格式"
                @input="zipInfo"
                v-model="addForm.zipUrl">
                  >
                  </upload-new> -->
              <w-upload-file
                style="overflow: hidden;"
                :videoWidth="1920"
                :videoHeight="620"
                :size="10"
                :drag="true"
                accept=".zip"
                btnText='上传互动包'
                tipsText="zip格式"
                @input="zipInfo"
                v-model="addForm.zipUrl">
              </w-upload-file>
            </div>
            <div class="form-item form-item2">
              <span class="form-item-title">互动内跳转</span>
              <el-radio-group class="art-radio-group" :class="{'disabled-box': isDisabledRadio}" v-model="addForm.subType" size="small">
                <el-radio-button :label="1">
                  <span @click="setTypes(1)">专题列表</span>
                </el-radio-button>
                <el-radio-button :label="2">
                  <span @click="setTypes(2)">大图</span>
                </el-radio-button>
                <el-radio-button :label="3">
                  <span @click="setTypes(3)">视频</span>
                </el-radio-button>
                <el-radio-button :label="4">
                  <span @click="setTypes(4)">文章</span>
                </el-radio-button>
                <el-radio-button :label="5">
                  <span @click="setTypes(5)">链接</span>
                </el-radio-button>
              </el-radio-group>
              <!-- 互动内跳转 -->
              <div class="link-box">
                <div class="sub-item item1" v-show="items === 1">
                  <el-button size="small" @click="selectFn">选择专题列表</el-button>
                  <span class="tips" v-text="`${showObj.relationName}（内容数：${showObj.relationContents}）`"></span>
   
                </div>
                <div class="sub-item item2" v-show="items === 2">
                  <w-upload-image
                    style="overflow: hidden;"
                    class="upload-img"
                    :imgWidth="1920"
                    :imgHeight="620"
                    :size="10"
                    tipsText="png/jpg格式"
                    v-model="addForm.subBigPic">
                  </w-upload-image>
                </div>
                <div class="sub-item item3" v-show="items === 3">
                  <w-upload-video
                    style="overflow: hidden;"
                    :videoWidth="1920"
                    :videoHeight="620"
                    :size="10"
                    tipsText="mp4格式"
                    v-model="addForm.subVideo">
                  </w-upload-video>
                </div>
                <div class="sub-item item4" v-show="items === 4">
                  <el-button size="small" @click="selectFn2">选择文章</el-button>
                  <span class="tips" v-text="`${showObj.relationName}`"></span>
                </div>
                <div class="sub-item item5" v-show="items === 5">
                  <el-input v-model="addForm.subLink" placeholder="请输入跳转链接"></el-input>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="foot-btn">
      <el-button size="small" @click="backFn">返回</el-button>
      <el-button size="small" type="primary" @click="createFn" :disabled="isDisabled">创建</el-button>
    </div>

    <!--专题列表样式-->
    <el-dialog
      class="item3-add-pop"
      title="请选择专题列表展示样式"
      :visible.sync="tmpVisible"
      :before-close="handleClose"
      center
    >
      <ul>
        <li v-for="item in tmpList" :key="item.id">
          <img :src="item.img" alt="列表样式" />
          <span class="title" v-text="item.title"></span>
        </li>
      </ul>
      <div slot="footer" class="dialog-footer">
        <el-button @click="tmpVisible = false">关闭</el-button>
        <el-button type="primary" @click="confirmFn">提交</el-button>
      </div>
    </el-dialog>

    <!-- 选择专题列表 -->
		<el-dialog
			title="选择专题列表"
			:visible.sync="dialogVisible"
			width="100%"
      class="boxdop"
			:before-close="handleClose">
			<div class="dialog-table">
				<div class="feature">
					<div class="page-title">选择专题列表&nbsp;&nbsp;&nbsp;<span class="tips">已根据展示位样式，筛选出建议选择的列表样式</span></div>
					<span class="feature-item filter" @click="drawer = true"><img src="@/assets/img/icon_sx.svg" />筛选</span>
				</div>
				<el-table :data="tableData" @selection-change="handleSelectionChange" style="width: 100%">
					<el-table-column type="selection" width="70" align="center"></el-table-column>
					<el-table-column prop="id" label="列表ID"></el-table-column>
					<el-table-column prop="title" label="专题列表名称"></el-table-column>
					<el-table-column prop="display_type" label="列表展示样式">
            <template slot-scope="scope">
              <span v-if="scope.row.display_type == 1">横排画廊样式</span>
              <span v-if="scope.row.display_type == 2">大图+方图方式</span>
              <span v-if="scope.row.display_type == 3">图片列表样式</span>
              <span v-if="scope.row.display_type == 4">图片竖向播放样式</span>
            </template>
          </el-table-column>
					<el-table-column prop="relation_subject_contents" label="列表内容数"></el-table-column>
					<el-table-column prop="relation_jump" label="存在关联跳转"></el-table-column>
					<el-table-column prop="create_at" label="创建时间"></el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-link type="primary" :underline="false" @click="lookBtn(scope.$index, scope.row)">查看</el-link>
						</template>
					</el-table-column>
				</el-table>
				<div class="tips-box">
					<i class="icon el-icon-info"></i>
					<span class="info">共<em class="num" v-text="total"></em>条数据</span>
				</div>
				<!-- 抽屉 -->
				<el-drawer
					title="选择关联内容"
					class="drawer-box"
					:visible.sync="drawer"
					:before-close="handleClose"
				>
					<el-form :label-position="'top'" :model="form" ref="form">
						<el-form-item v-for="(item, index) in filterForm1" :key="index" :label="item.label" :prop="item.prop">
							<el-input v-model="form[item.prop]" autocomplete="off" :placeholder="item.pl"></el-input>
						</el-form-item>
					</el-form>
					<div class="drawer-footer">
						<el-button @click="resetForm('form')">重 置</el-button>
						<el-button type="primary" @click="confirmFn2">确 定</el-button>
					</div>
				</el-drawer>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="savePopFn(0)" v-text="`确定`"></el-button>
			</span>
		</el-dialog>

    <!-- 选择文章 -->
    <el-dialog
			title="提示"
			:visible.sync="dialogVisible2"
			width="100%"
      class="boxdop"
			:before-close="handleClose">
			<div class="dialog-table">
				<div class="feature">
					<div class="page-title">选择文章</div>
					<span class="feature-item filter" @click="drawer = true"><img src="@/assets/img/icon_sx.svg" />筛选</span>
				</div>
				<el-table :data="tableData2" @selection-change="handleSelectionChange" style="width: 100%">
					<el-table-column type="selection" width="70" align="center"></el-table-column>
					<el-table-column prop="id" label="文章ID"></el-table-column>
					<el-table-column prop="title" label="文章标题"></el-table-column>
					<el-table-column prop="classify" label="文章分类">
            <template slot-scope="scope">
              <div class="tags_d" v-html="backClass(scope.row)"></div>
            </template>
          </el-table-column>
					<el-table-column prop="tags" label="标签">
            <template slot-scope="scope">
              <div class="tags_d" v-html="backTag(scope.row)"></div>
            </template>
          </el-table-column>
					<el-table-column prop="jump_to" label="当前绑定内容"></el-table-column>
					<el-table-column prop="creator" label="创建人"></el-table-column>
					<el-table-column prop="create_at" label="创建时间"></el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-link type="primary" :underline="false" @click="lookBtn(scope.$index, scope.row)">查看</el-link>
						</template>
					</el-table-column>
				</el-table>
				<div class="tips-box">
					<i class="icon el-icon-info"></i>
					<span class="info">共<em class="num" v-text="total"></em>条数据</span>
				</div>
				<!-- 抽屉 -->
				<el-drawer
					title="选择关联内容"
					class="drawer-box"
					:visible.sync="drawer"
					:before-close="handleClose"
				>
					<el-form :label-position="'top'" :model="form2" ref="form2">
						<el-form-item v-for="(item, index) in filterForm2" :key="index" :label="item.label" :prop="item.prop">
							<el-input v-model="form2[item.prop]" autocomplete="off" :placeholder="item.pl"></el-input>
						</el-form-item>
					</el-form>
					<div class="drawer-footer">
						<el-button @click="resetForm('form2')">重 置</el-button>
						<el-button type="primary" @click="confirmFn3">确 定</el-button>
					</div>
				</el-drawer>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible2 = false">取 消</el-button>
				<el-button type="primary" @click="savePopFn(1)" v-text="`确 定`"></el-button>
			</span>
		</el-dialog>
    <component @sucss="savePopFn" @close="close" v-bind:is="componentName" v-model="componentData"></component>
  </div>
</template>

<script>
import commonTop from "@/components/commonTop.vue"
import { checkURL } from '@/common/utils'
import com_zt_list from "../item1/com_zt_list.vue";
import com_wz_list from "../item1/com_wz_list.vue";

import uploadNew from "@/components/ui/uploadNew.vue";

import addVr from "./addVr.vue";
export default {
  components: {
    commonTop,
    com_wz_list,
    com_zt_list,
    addVr,
    uploadNew
  },
  data() {
    // 这里存放数据
    return {
      showObj:{
        type: 1,
        subType: 1
      },
      componentName:'',
      componentData:{},
      pageTitle: '新建內容',
      id: this.$route.query.id,
      type: this.$route.query.type,
      isDisabledRadio: this.$route.query.type == 'look',
      labelWidth: '100px',
      isDisabled: false, // 是否禁用
      drawer: false,
			dialogVisible: false,
			dialogVisible2: false,
      commonTopData: {
        commonleftbtn: [],
      },
      addForm: {
        author: '',
        tags: [],
        displayType: 1,
        type: 1,
        subType: 1,
        prev_url: '', // 预览图
        share_img_url: '', // 分享图
        title: "",
        subTitle: "",
        desc: "",
        jump_type: '',
        id: '', // 选中专题列表id
        zipUrl: '',
        fileUrl: '',
        bigPic: '',
        subBigPic: '',
        video: '',
        subVideo: '',
        link: '',
        subLink: '',
        deepLink: '',
        videoAll:{
          list:[]
        },
        vr: [
          {
            sub_infos:[
              {
                jump_type:'1',
                hd:{jump_type:'1'}
                
              }
            ]
          }
        ],
        prev_url_imagesa:'',
        prev_url_imagesb:'',
        prev_url_imagesc:'',
        prev_url_imagesd:'',
        h5: ''
      },
      item: 1,
      items: 1,
      tipsText: '640 * 302; png/jpg格式',
      relationName: '专题名称',
      relationContents: '0',
      form: [],
      form2:[],
      tmpVisible: false, // 专题列表是否显示
      tmpList: [
        { img: "http://static.zookingsoft.com/shiquaner-admin/pc/s4.png", title: "左右切换列表" },
        { img: "http://static.zookingsoft.com/shiquaner-admin/pc/s1.png", title: "三个一行列表" },
        { img: "http://static.zookingsoft.com/shiquaner-admin/pc/s2.png", title: "单行内容列表" },
        { img: "http://static.zookingsoft.com/shiquaner-admin/pc/s3.png", title: "上下切换列表" },
      ],
      tagList: [],
      filterForm1: [
				{prop: 'id', label: '内容ID', pl: '请输入内容ID检索'},
				{prop: 'title', label: '内容标题', pl: '请输入文章标题检索'},
				{prop: 'author', label: '创作者昵称', pl: '请输入创作者检索'},
				{prop: 'tags', label: '标签', pl: '请输入标签检索'}
			],
      filterForm2: [
				{prop: 'id', label: '文章ID', pl: '请输入内容ID检索'},
				{prop: 'title', label: '文章标题', pl: '请输入文章标题检索'},
				{prop: 'type', label: '文章分类', pl: '请选择文章分类检索'},
				{prop: 'tags', label: '标签', pl: '请输入标签检索'},
				{prop: 'author', label: '创建人', pl: '请输入创建人检索'}
			],
      selectedData: 0, // 已选择项目
      tableData: [],
      tableData2: [],
      total: '',
      total2: '',
      prev_url_list:[{url:''},{url:''},{url:''},{url:''}],
      share_url_list:[{url:''},{url:''},{url:''},{url:''}],
      taglist:[]
    };
  },
  mounted() {
    if (this.type === 'look') {
      this.pageTitle = '内容管理详情'
      this.isDisabled = true
      this.contentDetail()
    }
    if (this.type === 'edit') {
      this.pageTitle = '编辑内容管理'
      this.isDisabled = false
      this.contentDetail()
    }


    /*获取本地标签*/

    let tagsd = localStorage.getItem('bdtag')
    if(tagsd){
      this.taglist = JSON.parse(tagsd)
    }
  },
  watch:{
    'addForm.displayType'(val) {
     
      if (val == 1) {
        this.tipsText = '640 * 302; png/jpg格式'
      }
      if (val == 2) {
        this.tipsText = '250 * 360; png/jpg格式'
      }
      if (val == 3) {
        this.tipsText = '343 * 196; png/jpg格式'
      }
      if (val == 4) {
        this.tipsText = '302 * 302; png/jpg格式'
      }
      
      this.addForm.prev_url = this.prev_url_list[0].url
      this.addForm.share_img_url = this.share_url_list[0].url
    }
  },
  // 方法集合
  methods: {

    my_input(val) {
      if(this.addForm.displayType){
        this.prev_url_list[parseInt(this.addForm.displayType)-1].url = val
      }
      
    },
    my_input2(val) {
      if(this.addForm.displayType){
        this.share_url_list[parseInt(this.addForm.displayType)-1].url = val
      }
      
    },
    zipInfo(v1, v2) {
      this.addForm.fileUrl = v2
    },
    setType(n){
      if(this.item==n){
        return
      }
      this.item = n
      this.showObj = { type:n }
    },
    setTypes(n){
      if(this.items==n){
        return
      }
      this.items = n
      this.subType = { subType:n }
    },
    close(){
      this.componentName = ''
    },
    testfn(){
      this.addForm.tags = this.addForm.tags.map(el=>{
        if(el.length>6){
          el = el.substring(0,11)
        }
        return el
      })
    },
    testfn2(){
      this.addForm.show_tags = this.addForm.show_tags.map(el=>{
        if(el.length>6){
          el = el.substring(0,11)
        }
        return el
      })
    },
    backClass(da){
			let classify = [];
			try {
				classify = JSON.parse(da.classify)
			} catch (error) {
				console.log(error)
			}
			return classify.join('/')
		},
		backTag(da){
			let arr = [];
			try {
				arr = JSON.parse(da.tags);
			} catch (error) {
					console.log(error)
			}
			let str = '';
			arr.map(e=>{
				str+=`<span>${e}</span>`
			})
			return str;
		},
    selectFn() {
      this.componentName = 'com_zt_list'
    },
    selectFn2() {
      this.componentName = 'com_wz_list'
    },
    createFn() {
      // if(!this.addForm.prev_bg_url){
      //   this.$message('请上传背景大图')
      //   return
      // }
     
      if(this.addForm.videoAll.list.length==0){
        this.$message('请上传背景视频')
        return
      }
      let jumpTo = +this.addForm.type
      switch (jumpTo) {
        case 0: jumpTo = ''
        break
        case 1: jumpTo = this.showObj.id
        break
        case 2: jumpTo = this.addForm.bigPic
        break
        case 3: jumpTo = this.addForm.video
        break
        case 4: jumpTo = this.showObj.id
        break
        case 5: jumpTo = this.addForm.link
        break
        case 6: jumpTo = this.addForm.deepLink
        break
        case 7: jumpTo = 7
        break
        case 8: jumpTo = this.showObj.h5
        break
        default: jumpTo = 'other'
      }
      let subJumpTo = this.addForm.subType
      switch (subJumpTo) {
        case 1: subJumpTo = this.showObj.id
        break
        case 2: subJumpTo = this.addForm.subBigPic
        break
        case 3: subJumpTo = this.addForm.subVideo
        break
        case 4: subJumpTo = this.showObj.id
        break
        case 5: subJumpTo = this.addForm.subLink
        break
        default: subJumpTo = 'other'
      }
      let jumpToSub = {
        zipUrl: this.addForm.fileUrl || this.addForm.zipUrl,
        jump_type: this.addForm.subType,
        jump_to: subJumpTo
      }
      let data = {
        title: this.addForm.title,
        sub_title: this.addForm.subTitle,
        author: this.addForm.author,
        // view_num:this.addForm.view_num || '',
        // show_tags:JSON.stringify(this.addForm.show_tags),
        tags: JSON.stringify(this.addForm.tags),
       
        share_img_url: this.addForm.share_img_url,
        desc: this.addForm.desc,
        jump_type: this.addForm.type,
        jump_to: this.addForm.type == 8 ? JSON.stringify(jumpToSub) : jumpTo,

        prev_bg_url: this.addForm.prev_bg_url,
        prev_bg_mp4: this.addForm.videoAll.list[0].response?this.addForm.videoAll.list[0].response.data.url:this.addForm.videoAll.list[0].url,
      }

      // if(data.view_num && !/(^[0-9]\d*$)/.test(data.view_num)){
      //   this.$message.warning('热度值请输入正整数')
      //   return
      // }
      if (!this.addForm.author) {
        this.$message.warning('创作者昵称不能为空')
        return
      }
      if (!this.addForm.tags) {
        this.$message.warning('标签不能为空')
        return
      }

      if(!this.addForm.prev_url_imagesa && !this.addForm.prev_url_imagesb
       && !this.addForm.prev_url_imagesc && !this.addForm.prev_url_imagesd
      ){
        this.$message('至少上传一个展示图')
        return 
      }
      data.prev_url_images = [];
      let display_type=0;
      if(this.addForm.prev_url_imagesa){
        
        data.prev_url_images.push({
          display_type:'1',
          img_url:this.addForm.prev_url_imagesa
        })
      }
      if(this.addForm.prev_url_imagesb){
        data.prev_url_images.push({
          display_type:'2',
          img_url:this.addForm.prev_url_imagesb
        })
      }
      if(this.addForm.prev_url_imagesc){
        data.prev_url_images.push({
          display_type:'3',
          img_url:this.addForm.prev_url_imagesc
        })
      } 
      if(this.addForm.prev_url_imagesd){
        data.prev_url_images.push({
          display_type:'4',
          img_url:this.addForm.prev_url_imagesd
        })
      }
      display_type = data.prev_url_images[0].display_type;
      data.display_type = display_type;
      data.prev_url_images = JSON.stringify(data.prev_url_images);
     
      if (!this.addForm.title) {
        this.$message.warning('标题不能为空')
        return
      }
      if (!this.addForm.subTitle) {
        this.$message.warning('副标题不能为空')
        return
      }
      if (!this.addForm.desc) {
        this.$message.warning('描述不能为空')
        return
      }
      if (jumpTo == 1 && !this.showObj.id) {
        this.$message.warning('专题列表不能为空')
        return
      }
      if (jumpTo == 2 && !this.addForm.bigPic) {
        this.$message.warning('大图不能为空')
        return
      }
      if (jumpTo == 3 && !this.addForm.video) {
        this.$message.warning('视频不能为空')
        return
      }
      if (jumpTo == 5 && !this.addForm.link) {
        this.$message.warning('链接不能为空')
        return
      }
      if (jumpTo == 5 && !checkURL(this.addForm.link)) {
        this.$message.warning('请输入正确的url')
        return
      }
      if (jumpTo == 6 && !this.addForm.deepLink) {
        this.$message.warning('deepLink参数链接不能为空')
        return
      }

      if ((+this.addForm.type) == 8 && !this.addForm.zipUrl) {
        this.$message.warning('互动包不能为空')
        return
      }

      if ((+this.addForm.type) == 8 && !this.showObj.relationName && this.items ==1) {
        this.$message.warning('请选择互动H5下的专题列表')
        return
      }
      if ((+this.addForm.type) == 8 && !this.addForm.subBigPic && this.items ==2) {
        this.$message.warning('请上传互动H5下的大图')
        return
      }
      if ((+this.addForm.type) == 8 && !this.addForm.subVideo && this.items ==3) {
        this.$message.warning('请上传互动H5下的视频')
        return
      }

      if ((+this.addForm.type) == 8 && !this.showObj.relationName && this.items ==4) {
        this.$message.warning('请选择互动H5下的文章')
        return
      }

      if ((+this.addForm.type) == 8 && !this.addForm.subLink && this.items ==5) {
        this.$message.warning('请输入互动H5下的跳转链接')
        return
      }
 
      if(jumpTo == 7){
        let obj = this.backVr(this.addForm.vr)
     
        if(!obj){return}
        data.jump_to = JSON.stringify({vr:obj})
      }
      /*处理更多视频*/
      let prev_bg_mp4_infos = [];
      this.addForm.videoAll.list.map(e=>{
        prev_bg_mp4_infos.push({
          width:e.width,
          url:e.response?e.response.data.url:e.url,
          height:e.height
        })
      })
      data.prev_bg_mp4_infos = JSON.stringify(prev_bg_mp4_infos);
    


      this.addForm.tags.map(e=>{
        if(this.taglist.indexOf(e)==-1){
          this.taglist.push(e)
        }
      })
    
      localStorage.setItem('bdtag',JSON.stringify(this.taglist))

      // 新建内容
      if (this.type == 'add') {
        this.api.addContent(data).then(res => {
        if (!res) return
        this.$message.success('创建成功')
        this.$router.push("/art/item3?tabs=comNr")
      })
      }

     




      // 编辑内容
      if (this.type == 'edit') {
        data.id = this.id
        this.api.editContent(data).then(res => {
          if (!res) return
          this.$message.success('编辑成功')
          this.$router.push('/art/item3?tabs=comNr')
        })
      }
    },
    vrDatacr(da){


      return da.vr.map(e=>{
        e.sub_infos = e.sub_infos.map(e2=>{
          e2.bigPic = '';
          e2.video = '';
          e2.link = '';
          if (e2.jump_type == 2) {
            e2.bigPic = e2.jump_to
          }
          if (e2.jump_type == 3) {
            e2.video = e2.jump_to
          }
          if (e2.jump_type == 5) {
            e2.link = e2.jump_to
          }
          if (e2.jump_type == 6) {
            e2.deepLink = e2.jump_to
          }
          e2.hd = {};
          if(e2.jump_type=='8'){
            e2.hd = {
              jump_type:e2.jump_to.jump_type,
              jump_to:e2.jump_to.jump_to,
              zip:e2.jump_to.zipUrl,
              zipUrl:e2.jump_to.zipUrl,
              relation_contents: e2.jump_to.relation_contents,
              relation_title: e2.jump_to.relation_title,
            }
            e2.jump_to = '';            
          }
          return e2
        })
        return e;
      })

    },
    backVr(da){
      let arr = [];
      let mapa = ['bigPic','video','link','deepLink'];
      let mapb = ['1','4'];
      let mapc = ['2','3','5','6'];
      for(var i=0,n=da.length;i<n;i++){
        if(!da[i].main_pic_url){
          this.$message('请上传场景平面图')
          return false
        }
        if(!da[i].prev_url){
          this.$message('请上传场景切换预览图')
          return false
        }
        let pr = {
          main_pic_url:da[i].main_pic_url,
          prev_url:da[i].prev_url,
          sub_infos:[]
        };
        for(var i2=0,n2=da[i].sub_infos.length;i2<n2;i2++){
          let ond = da[i].sub_infos[i2];
          if(!ond.x){
            this.$message('请填写X坐标')
            return false
          }
          if(!ond.y){
            this.$message('请填写y坐标')
            return false
          }
          if(!ond.width){
            this.$message('请填写宽度')
            return false
          }
          if(!ond.height){
            this.$message('请填写高度')
            return false
          }
 
          
          if(mapb.indexOf(ond.jump_type)!=-1 && !ond.jump_to){
            this.$message('请选择跳转类容')
            return false
          }   
          let jump_to = ond.jump_to; 
          let ony = mapc.indexOf(ond.jump_type);  
          
          if(ony!=-1){
            if(!ond[mapa[ony]]){
              this.$message('请填写跳转类容')
              return false
            }
            jump_to = ond[mapa[ony]]

          }
          if(ond.jump_type=='8'){
            jump_to = {
              jump_type:ond.hd.jump_type,
              zipUrl:ond.hd.zip
            };


            if(mapb.indexOf(ond.hd.jump_type)!=-1 && !ond.hd.jump_to){
              this.$message('请选择跳转类容')
              return false
            }   
            let jump_to2 = ond.hd.jump_to; 
            let ony = mapc.indexOf(ond.hd.jump_type);  
            
            if(ony!=-1){
              if(!ond.hd[mapa[ony]]){
                this.$message('请填写跳转类容')
                return false
              }
              jump_to2 = ond.hd[mapa[ony]]

            }
            jump_to.jump_to = jump_to2;
          }
          pr.sub_infos.push({
            x:ond.x,
            y:ond.y,
            width:ond.width,
            height:ond.height,
            jump_type:ond.jump_type,
            jump_to:jump_to,
          })
        }
        arr.push(pr);

      }
      
      return arr;
    },


    contentDetail () {

      let data = {
        id: this.id
      }
      this.api.contentDetail(data).then(res => {
        if (!res) return
        this.addForm.author = res.author
        
        try {
				this.addForm.tags = JSON.parse(res.tags)
        } catch (error) {
          this.addForm.tags = [];
        }
       
        try {
				// this.addForm.show_tags = JSON.parse(res.show_tags)
        } catch (error) {
          // this.addForm.show_tags = [];
        }
        // this.addForm.view_num = res.view_num;
        //  1 方图列表样式  2 大图+小图列表样式  3 长图列表样式   4 横图列表样式
        let display_type = res.display_type;
        
   
        const setIm = (on,img)=>{
         
             
            if(on==1){
      
              this.addForm.prev_url_imagesa = img;
           
              
            }
        
            if(on==2){
              this.addForm.prev_url_imagesb = img;
            }
            if(on==3){
              this.addForm.prev_url_imagesc = img;
            }
        
            if(on==4){
              this.addForm.prev_url_imagesd = img;
            }
           
        }
    
        if(res.prev_url_images){
          let po = [];
          try {
            po = JSON.parse(res.prev_url_images);
          } catch (error) {
            po = [];
          }
          
          if(po[0]){
            display_type = po[0].display_type;
             
          }
   
          po.map(e=>{
            setIm(e.display_type,e.img_url)
          })

        }else{
          setIm(res.display_type,res.prev_url)
   
        }
         
       
        this.addForm.tmpImg = this.tmpList[display_type - 1].img
        this.addForm.tmpTitle = this.tmpList[display_type - 1].title
        this.addForm.displayType = +display_type
        this.addForm.prev_url = res.prev_url
          this.addForm.share_img_url = res.share_img_url
                  this.addForm.prev_bg_url = res.prev_bg_url
        this.addForm.prev_bg_mp4 = res.prev_bg_mp4

        /*设置更多视频*/
        let prev_bg_mp4_infos = res.prev_bg_mp4_infos?JSON.parse(res.prev_bg_mp4_infos):[];
        prev_bg_mp4_infos.map(e=>{
          e.percentage = 100
        })
        /*兼容以前数据*/
        if(prev_bg_mp4_infos.length==0 && res.prev_bg_mp4_info){
          prev_bg_mp4_infos.push({
            url:this.addForm.prev_bg_mp4,
            percentage:100
          })
        }
      
      this.addForm.videoAll.list = prev_bg_mp4_infos
    
        
        /*type赋值会导致图片清空做异步赋值*/
        this.$nextTick(()=>{
          
          this.prev_url_list[parseInt(this.addForm.displayType)-1].url = res.prev_url
          this.share_url_list[parseInt(this.addForm.displayType)-1].url = res.share_img_url
        })
        this.addForm.title = res.title
        this.addForm.subTitle = res.sub_title
        this.addForm.desc = res.desc
        /*跳转内容*/
        this.addForm.type = +res.jump_type
        this.item = +res.jump_type
        if(res.jump_type == '1' || res.jump_type=='4'){
          this.showObj.id = res.jump_to
        }
        if(res.jump_type == '2'){
          this.addForm.bigPic = res.jump_to
        }
        if(res.jump_type == '3'){
          this.addForm.video = res.jump_to
        }
        if(res.jump_type == '5'){
          this.addForm.link = res.jump_to
        }
        if(res.jump_type == '6'){
          this.addForm.deepLink = res.jump_to
        }

        if (res.jump_type == 8) {
          this.items = +res.jump_to.jump_type
          this.addForm.subType = +res.jump_to.jump_type
          if (res.jump_to.jump_type == 1) {
            this.showObj.id = res.jump_to.jump_to
          }
          if (res.jump_to.jump_type == 2) {
            this.addForm.subBigPic = res.jump_to.jump_to
          }
          if (res.jump_to.jump_type == 3) {
            this.addForm.subVideo = res.jump_to.jump_to
          }
          if (res.jump_to.jump_type == 4) {
            this.showObj.id = res.jump_to.jump_to
          }
          if (res.jump_to.jump_type == 5) {
            this.addForm.subLink = res.jump_to.jump_to
          }





          this.$nextTick(()=>{
            this.addForm.zipUrl = res.jump_to.zipUrl
            this.addForm.subType = res.jump_to.jump_type
          })
        }

        if(res.jump_type==7){
          let po =res.jump_to;

          this.addForm.vr = this.vrDatacr(po)
          this.addForm.jump_to = '';
        }

        this.showObj.relationName = res.relation_title || (res.jump_to.relation_title?res.jump_to.relation_title:'')
        this.showObj.relationContents = res.relation_contents || (res.jump_to.relation_contents?res.jump_to.relation_contents:'') 
      })
    },
    backFn() {
      this.$router.push("/art/item3?tabs=comNr")
    },
    savePopFn (da) {
      this.close();
      if(!da){
        return
      }
      this.showObj.id = da.id
      this.showObj.relationName = da.title
      this.showObj.relationContents = da.relation_subject_contents
      this.showObj.display_type = da.display_type
      this.showObj.jump_type = da.type
      this.showObj.jump_to = da.jump_to
		},
		resetForm(formName) {
			this.$refs[formName].resetFields()
    },
		// 全选事件
    handleSelectionChange (val) {
      this.selectedData = val
    },
    lookBtn () {
      this.$message('look')
    },
    // 专题样式确定
    confirmFn() {

    },
    confirmFn2(){
      this.getPopData(this.form)
    },
    confirmFn3(){
      this.getPopData2(this.form2)
    },
    getPopData (pr) {
      this.api.subjectList(pr||'').then(res => {
				if (!res) return
				let { data, total } = res
				this.tableData = data
        this.total = total
			})
		},
    getPopData2 (pr) {
			this.api.getArticleList(pr || '').then(res => {
				if (!res) return
				let { data, total } = res
				this.tableData2 = data
        this.total2 = total
			})
		},
    handleClose(done) {
      done()
      this.tmpVisible = false;
    },
  },
};
</script>
<style>
.boxdop .el-dialog__footer{
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #fff;
}
.boxdop .el-dialog__body{
  padding-bottom: 70px !important;
}
</style>
<style lang='scss' scoped>
.item3-add-cont {
  height: 100vh;
  background-color: #fff;
  .page-title {
    margin: 0 0 30px 30px;
    font-size: 16px;
  }
  .top-title {
    padding-left: 150px;
    .add-form {
      .tips {
        color: #979797;
      }
    }
    .title-item {
      display: flex;
      margin-bottom: 15px;
      .select-btn {
        display: inline-block;
        width: 110px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border-radius: 4px;
        font-size: 12px;
        cursor: pointer;
        border: 1px solid #c4c4c4;
      }
    }
  }
  .content {
    position: relative;
    margin-top: 30px;
    padding-left: 150px;
    border-top: 1px solid #e5e5e5;
    .art-radio-group {
      display: inline-block;
    }
    .jump-link-group {
      .art-radio-group {
        display: inline-block;
        margin: 0;
      }
      .item8 {
        width: 598px;
        padding: 20px;
        border: 1px dashed #999;
        border-radius: 4px;
      }
      .form-item {
        position: relative;
        .form-item-title {
          display: inline-block;
          min-width: 100px;
          color: #606266;
        }
        .link-box {
        }
        .sub-item {
          margin-left: 100px;
        }
      }
      .form-item1 {
        display: flex;
      }
      .disabled-box {
        pointer-events: none;
        cursor: default;
      }
    }
    .content-title {
      display: inline;
      position: relative;
      left: -120px;
    }
    .tips {
      margin-left: 10px;
      display: inline;
      color: #828282;
    }
    .all-online {
      width: 400px;
      margin: 20px 0 10px;
      text-align: right;
      cursor: pointer;
      color: #33b3ff;
    }
  }
  .foot-btn {
    .el-button {
      width: 100px;
    }
  }
  .item3-add-pop {
    /deep/.el-dialog {
      width: 60%;
    }
    ul {
      display: flex;
      align-items: center;
      justify-content: center;
      li {
        margin-right: 20px;
        cursor: pointer;
        .title {
          display: block;
        }
      }
    }
  }
  .el-input,
  .el-select,
  .el-textarea {
    width: 460px !important;
    /deep/.el-input__count {
      bottom: -10px;
    }
  }
}
</style>

<style lang="scss">
  .item3-add-cont {
    .add-form {
      .el-textarea__inner {
        font-family: auto;
      }
    }
  }
  .sub-item .w-upload-image-review {
    img {
      width: 100%;
    }
  }
 .tags_d>span{
    display: inline-block;
    vertical-align: top;
    padding: 2px 5px;

    margin: 2px;
    font-size: 12px;
    border-radius: 5px;
    color: #fff;
    background-color: whitesmoke;

    color: #979797;
    border: 1px solid #eaeaea;
 }
</style>